import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QUERY_PREFIX } from '@src/query';
import { SimilarRequestType } from '@src/types/api';
import { MediaView } from 'common';
import { findMediaSimilar } from './api';

/**
 * Find products linked to any media
 */
export const useQueryMediaSimilar = (mediaId: string, similiType: SimilarRequestType, stringifiedQuery?: string, config?: Omit<UseQueryOptions<MediaView[]>, 'queryKey' | 'queryFn'>) => useQuery({ queryKey: [QUERY_PREFIX.MEDIA_SIMILAR, mediaId, { similiType }, stringifiedQuery], queryFn: () => findMediaSimilar(mediaId, [similiType], stringifiedQuery), ...config });
